import { render, staticRenderFns } from "./FormCustomer.vue?vue&type=template&id=554ad1ec&scoped=true"
import script from "./FormCustomer.vue?vue&type=script&lang=js"
export * from "./FormCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554ad1ec",
  null
  
)

export default component.exports